// extracted by mini-css-extract-plugin
module.exports = {"detetion-page-menu-filter":"detetion-page-menu-filter-d053f7f31ae60579ecda72ec571a090e"};